import _toConsumableArray from "/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import deepMerge from 'deepmerge'; // eslint-disable-next-line @typescript-eslint/no-explicit-any

function mergeArrays(base, override, helpers) {
  var cloneUnlessOtherwiseSpecified = helpers.cloneUnlessOtherwiseSpecified,
      isMergeableObject = helpers.isMergeableObject; // clone the target array

  var final = _toConsumableArray(base);

  override.forEach(function (overrideItem, index) {
    var baseItem = base[index];

    if (isMergeableObject(overrideItem)) {
      // if we encounter a "mergeable" object, merge it with the base item

      /* eslint-disable @typescript-eslint/no-use-before-define */
      final[index] = mergeTwo(baseItem, overrideItem);
    } else {
      // otherwise just replace whatever was in the base array with the override
      final[index] = cloneUnlessOtherwiseSpecified(overrideItem, helpers);
    }
  });
  return final;
} // eslint-disable-next-line @typescript-eslint/ban-types


function mergeTwo(base, override) {
  return deepMerge(base, override, {
    arrayMerge: mergeArrays
  });
} // eslint-disable-next-line @typescript-eslint/ban-types


function merge(propsObjects) {
  return deepMerge.all(propsObjects, {
    arrayMerge: mergeArrays
  });
}

export { merge };